module.exports = __webpack_public_path__ + "static/media/telecom.0380f0a1.jpg";